import '@tunasong/ui-lib/theme/tokens.css'
import '@tunasong/ui-lib/primitives/primitives.css'
import { Provider, rootStore } from '@tunasong/redux'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app.js'
import { SEO } from './components/seo.js'

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById('root')!)

root.render(
  <React.StrictMode>
    <SEO title="Tunasong" />
    <Provider store={rootStore}>
      <App />
    </Provider>
  </React.StrictMode>
)
